import { formatRegistryDateTime } from "@/components/ncrm/privacy/privacyWorkspaceContracts.mjs";

const REASONS = Object.freeze({ doi_disabled: "disabled", invitations_disabled: "disabled", state_ineligible: "state",
  policy_blocked: "policy", manager_required: "manager", notice_unavailable: "notice",
  invitation_cooldown_active: "cooldown", invitation_send_limit_reached: "quota", tenant_read_only: "readOnly" });

export const invitationReasonText = (vm, code, limits) => {
  const smtpKey = `ncrm.contacts.dataProtection.record.doiResend.reasons.${code}`;
  if (vm.$te(smtpKey) && code !== "doi_disabled") return vm.$t(smtpKey);
  return vm.$t(`ncrm.contacts.dataProtection.record.invitation.${REASONS[code] || 'unavailable'}`, {
    at: formatRegistryDateTime(limits?.cooldown_until),
  });
};
